import { mapActions } from 'vuex'
import jsPDF from 'jspdf'
import { TipoControladorSenha } from '@/utils/controladores'
import { exportComprovantePDF } from '@/services/pdf/PdfService';
import { applyPdfStyle } from '@/services/pdf/pesagem/template';

export const methods = {
  ...mapActions('agendamentos', [
    'getGerarSenhasAtendimentoType',
    'updateAtributoAgendamento',
  ]),
  ...mapActions('gerencial', ['addControladorDoGate']),
  ...mapActions('template', ['errorMessage']),
  getQuebraSobraKg(agendamento, pedido) {
    if (pedido.quantidade_agendada == 0 || agendamento.peso_liquido == null)
      return 0
    return (
      agendamento.peso_liquido - this.converteKg(pedido.quantidade_agendada)
    )
  },
  async baixarPDF() {
    const pdf = new jsPDF({
      unit: 'mm',
      format: [80, 300],
    })

    pdf.setFont('courier') // 🔥 importante
    pdf.setFontSize(8)

    let y = 5
    const maxWidth = 76 // margem lateral

    const addLine = (text = '') => {
      const lines = pdf.splitTextToSize(String(text), maxWidth)
      lines.forEach((line) => {
        pdf.text(line, 2, y)
        y += 4
      })
    }

    const center = (text) => {
      const lines = pdf.splitTextToSize(String(text), maxWidth)
      lines.forEach((line) => {
        pdf.text(line, 40, y, { align: 'center' })
        y += 4
      })
    }

    const line = () => {
      addLine('--------------------------------')
    }

    // 🧾 TÍTULO
    center('COMPROVANTE DE PESAGEM')
    line()

    const ag = this.agendamento

    addLine(`Fornecedor: ${ag.fornecedor.business_name}`)
    addLine(`Ticket: ${ag.sequencias?.[0]?.sequencia || '-'}`)
    addLine(`Veículo: ${ag.veiculo.placa_cavalo || '-'}`)
    addLine(`Motorista: ${ag.motorista.user.name || '-'}`)
    addLine(`Navio: ${ag.navio?.descricao || '-'}`)
    addLine(`Operação: ${ag.tipo_operacao.descricao}`)
    addLine(`DI: ${ag.di || '-'}`)
    addLine(`Transportadora: ${ag.transportadora.business_name || '-'}`)
    addLine(`Cliente: ${ag.cliente.business_name || '-'}`)
    addLine(`Destinatário: ${ag.destinatario.business_name}`)

    line()

    ag.pedidos_agendados.forEach((pedido) => {
      addLine(`Produto: ${pedido.pedido.subProduto.descricao}`)
      addLine(`Qtd: ${this.converteKg(pedido.quantidade_agendada)} kg`)
      addLine(`NF: ${pedido.numero_nfe}`)
      addLine(`Pedido: ${pedido.pedido.numero_pedido}`)

      addLine(
        `TARA: ${ag.pesagem_tara?.peso || '-'}`
      )
      addLine(
        `BRUTO: ${ag.pesagem_bruto?.peso || '-'}`
      )
      addLine(`Líquido: ${ag.peso_liquido || '-'}`)

      addLine(
        `Quebra(KG): ${this.getQuebraSobraKg(ag, pedido)}`
      )
      addLine(
        `Quebra(%): ${this.getQuebraSobraPercentual(ag, pedido)}%`
      )

      line()
    })

    addLine(`Obs: ${ag.observacao || '-'}`)
    addLine(`Operador: ${ag.operador || '-'}`)

    addLine('')
    addLine('Ass: ________________________')

    pdf.save('comprovante.pdf')
  },
  getQuebraSobraPercentual(agendamento, pedido) {
    if (pedido.quantidade_agendada == 0 || agendamento.peso_liquido == null)
      return 0
    return (
      (agendamento.peso_liquido / this.converteKg(pedido.quantidade_agendada)) *
      100
    ).toFixed(2)
  },
  async imprimirComprovante() {
    // await this.gerarSenhas()
    setTimeout(window.print, 500)
  },
  getFormaPagamentoNameById(id) {
    return (
      Object.values(this.FormaPagamento).find((f) => f.id == id)?.name ||
      'Tipo I nválido'
    )
  },

  prepareSubProdutos() {
    const { pedidos_agendados } = this.agendamento

    return pedidos_agendados.map((p) => ({
      id: p.pedido.subProduto.id,
      tipo: TipoControladorSenha.SubProduto.id,
    }))
  },

  converteKg(item) {
    return (parseFloat(item) * 1000).toFixed(0)
  },

  prepareServicos() {
    const { servicos_triados } = this.agendamento

    return servicos_triados.map((s) => ({
      id: s.servico.id,
      descricao: s.servico.descricao,
      tipo: TipoControladorSenha.Servico.id,
    }))
  },

  prepareData() {
    const { fornecedor, tipo_operacao } = this.agendamento
    const subProdutos = this.prepareSubProdutos()
    const servicos = this.prepareServicos()
    let data = []
    // if (
    //   servicos.find(
    //     (item) =>
    //       item.descricao === 'TRIAGEM FERTILIZANTE' ||
    //       item.descricao === 'TRIAGEM (RETORNO)' ||
    //       item.descricao === 'TRIAGEM RETORNO' ||
    //       item.descricao === 'TRIAGEM' ||
    //       item.descricao === 'TRIAGEM ANTECIPADO' ||
    //       item.descricao === 'SEM CADASTRO / AGENDAMENTO' ||
    //       item.descricao === 'SERVIÇO DE REGULARIZAÇÃO CADASTRAL'
    //   )
    // ) {
    data = data
      .concat(
        subProdutos[0],
        servicos.filter(
          (item) =>
            item.descricao !== 'TRIAGEM FERTILIZANTE' ||
            item.descricao !== 'TRIAGEM (RETORNO)' ||
            item.descricao !== 'TRIAGEM RETORNO' ||
            item.descricao !== 'TRIAGEM' ||
            item.descricao !== 'TRIAGEM ANTECIPADO' ||
            item.descricao !== 'SEM CADASTRO / AGENDAMENTO' ||
            item.descricao !== 'SERVIÇO DE REGULARIZAÇÃO CADASTRAL'
        )
      )
      .map((i) => ({
        utilizador: fornecedor.fornecedor_id,
        objeto_id: i.id,
        tipo_operacao: tipo_operacao.id,
        tipo: i.tipo,
      }))
    // } else {

    //   data = data.concat(servicos).map((i) => ({
    //     utilizador: fornecedor.fornecedor_id,
    //     objeto_id: i.id,
    //     tipo_operacao: tipo_operacao.id,
    //     tipo: i.tipo,
    //   }))
    // }
    return data
  },

  getSenhaPrincipal(senhas, subProduto) {
    return senhas.find(
      (s) => s.tipo == subProduto.tipo && s.objeto_id == subProduto.objeto_id
    ).sequencia
  },

  async criarControlador() {
    try {
      const data = this.prepareData()
      const controlador = [
        {
          ...data[0],
          criador: this.empresaAtual.public_id,
          limitador: 9999,
        },
      ]
      await this.addControladorDoGate({ controladores: controlador })
    } catch (error) {
      if (error.response) {
        this.errorMessage(error.response.data)
        return
      }
      if (error.message) {
        this.errorMessage(error.message)
        return
      }
      this.errorMessage(error)
    }
  },
  async gerarSenhas(criar_controlador = false) {
    const data = this.prepareData()
    try {
      const senhas = await this.getGerarSenhasAtendimentoType({
        agendamento: this.agendamento,
        dados: data,
      })
      this.updateAtributoAgendamento({
        valor: [].concat(this.agendamento.senhas, senhas),
        nomeAtributo: 'senhas',
      })
      if (senhas.length > 0) {
        this.senha = this.getSenhaPrincipal(senhas, data[0])
      } else {
        if (!criar_controlador) {
          this.gerarSenhas(true)
        }
        this.errorMessage(
          'Nenhum controlador encontrado. Necessário cadastrar para permitir a geração de senha.'
        )
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        this.errorMessage('Um ou mais controladores não foram encontrados')
        return
      }
      if (error.response) {
        this.errorMessage(error.response.data)
        return
      }
      if (error.message) {
        this.errorMessage(error.message)
        return
      }
      this.errorMessage(error)
    }
  },

  async exportPDF() {
    if (this.exportingPDF) return;
    this.exportingPDF = true;

    try {
      const element = this.$refs.exportpdf?.$el || this.$refs.exportpdf;
      await exportComprovantePDF(
        element, `comprovante-pesagem-${this.agendamento.public_id}.pdf`, applyPdfStyle
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.exportingPDF = false;
    }
  }
}
